import { render, staticRenderFns } from "./AmountDigitInput.vue?vue&type=template&id=5ba3a23e&scoped=true"
import script from "./AmountDigitInput.vue?vue&type=script&lang=js"
export * from "./AmountDigitInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba3a23e",
  null
  
)

export default component.exports